export default function (a, b) {
  this[a] = this.splice(b, 1, this[a])[0];
  return this;
}
